<script>
import SvgTransition from '@/views/Admin/Public/SvgTransition.vue'
import config from "@/helpers/config"
export default {
    components:{ SvgTransition },
    props: ['selectedTab', 
            'publicPage',
            'publicPageHome',
            'publicPageCommunity',
            'publicPageImages',
            'publicPageColors',
            'colors'],
    data(){
      return {
       
      }
    },  
    mounted() {
        
    },
    methods: {
      getBackgroundImage(location)
        {
            var img = this.publicPageImages.find(x => x.location == location);
            if(img == undefined)
                return '';

            return  { 
                'background-image': 'url(' + this.url + 'uploads/'+ this.customer.id+'/images/'+ img.image_name,
                'background-position': img.position
             };
        },
    },
    computed:
    {
        customer() { return this.$store.state.customer }, 
        user() {return this.$store.state.user; },
        availableBookings() {return this.$store.state.availableBookings == null ? [] : this.$store.state.availableBookings.filter(x => x.include_in_public_site); },
        courses() {return this.$store.state.courses == null ? [] : this.$store.state.courses.filter(x => x.is_public_course); },
        notifications() { return this.$store.state.notifications != null ? this.$store.state.notifications.filter(x => x.include_in_public_site) : [] },
        boardMembers() { return this.$store.state.boardMembers != null ? this.$store.state.boardMembers : [] },
        workGroups() {   return this.$store.state.workGroups != undefined ? this.$store.state.workGroups : [] },
        statutes() {  return this.$store.state.statutes != null ? this.$store.state.statutes : []  },
        rulesOfProcedure() {  return this.$store.state.rulesOfProcedure != null ? this.$store.state.rulesOfProcedure : []   },  
        images() {  return this.$store.state.images != null ? this.$store.state.images : []  },  
        news() {  return this.$store.state.news != null ? this.$store.state.news : []  },  
        courseInstructors() {  return this.$store.state.courseInstructors != null ? this.$store.state.courseInstructors : []  },  
        url() { return config.urlToServer },              
    },
}

</script>
<template>
  <div class="top-public" :style="getBackgroundImage(selectedTab)">                           
      <SvgTransition :publicPage="publicPage"></SvgTransition>     
  </div>
</template>

<style scoped>
.top-public
{
    background-image: url('@/assets/imgs/harbour.jpg');
    background-repeat: no-repeat;
    height: 600px;
    width: 100%;
    background-size: cover;
    background-position: center;
    position: relative;
}
</style>